module.exports = __webpack_public_path__ + "static/media/kasumin.c6e5cd74.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/climasense/tizon_fuego_manzano/kasumin.png
// module id = 1749
// module chunks = 3